




























































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import IRolePermission from '@/store/models/IRolePermission';
import INoticeOfLossPictures from '@/store/models/INoticeOfLossPictures';
import IBlob from '@/store/models/IBlob';
import { v4 as uuidv4 } from 'uuid';
@Component({
    components: {
    }
})
export default class OutboundsDeliveryNoteNoticeOfLossPictures extends Vue {
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];
    @Prop({ type: Array, required: true })
    BlobsSource !: IBlob[];
    @Prop({ type: Array, required: true })
    OutboundNoticeOfLossPictures !: INoticeOfLossPictures[];

    isPictureSelected: boolean = false;
    currFiles: any[] = [];
    files: any[] = [];
    selectedPictureNoticeOfLoss: any[] = [];
    imageurl: string = "";
    blobUrlselected: string= "";
    selectedBlob: IBlob = {} as IBlob;
    remove(index: number) {
        this.files.splice(index, 1);
    }

    inputChanged() {
        this.files = [
            ...this.currFiles, ...this.files
        ];
    }

    uploadFiles() {
        if (!this.files) {
            this.$emit("showMessageWarning", "Please select a picture");
        } else {
            let formDatas : FormData = this.getFormData();
            let fileNames : string[] = [];
            for (let i in this.files) {
                fileNames.push(this.files[i].name);
            }
            this.$emit('uploadOutboundNoticeOfLossPicture', formDatas);
            this.currFiles = [];
            this.files = [];
        }
    }

    getFormData() : FormData {
        let formData = new FormData();
        for (let file of this.files) {
            let name = uuidv4();
            formData.append("files", file, name);
        }

        return formData;
    }

    selectedImage(blob: IBlob) {
        this.selectedBlob = blob;
        if (this.blobUrlselected === blob.blobUrl) {
            this.blobUrlselected = "";
            this.isPictureSelected = false;
        } else {
            this.blobUrlselected = blob.blobUrl;
            this.isPictureSelected = true;
        }
    }

    downloadPictures(noticeOfLossPictures: INoticeOfLossPictures[]) {
        this.$emit("downloadOutboundNoticeOfLossPictures", noticeOfLossPictures);
    }

    deletePicture() {
        if (this.selectedBlob) {
            let pictureIndex: number = this.OutboundNoticeOfLossPictures.findIndex(p => p.url === this.selectedBlob.url);
            this.$emit('deleteNoticeOfLossPicture', this.OutboundNoticeOfLossPictures[pictureIndex]);
            this.blobUrlselected = "";
            this.isPictureSelected = false;
        }
    }
}
